import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAuthPayload, getUserTypeName, isAdminUser } from "../../admin/navigation/adminNavigation";

const Protected = ({ children, allowedRoles }) => {
  const authState = useSelector((state) => state.auth);
  const location = useLocation();
  const user = getAuthPayload(authState);

  if (!authState?.isAuthenticated || !user?.accessToken) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  const userType = String(getUserTypeName(authState) || "").toUpperCase().trim();
  const isAdmin = isAdminUser(authState);

  // If specific allowed roles are required and user is not super admin
  if (allowedRoles && allowedRoles.length > 0 && !isAdmin) {
    const isAllowed = allowedRoles.some(
      (role) => role.toUpperCase().trim() === userType
    );

    if (!isAllowed) {
      if (userType === "PARTNER") {
        return <Navigate to="/partner/workspace" replace />;
      }
      if (userType === "CUSTOMER") {
        return <Navigate to="/customer/workspace" replace />;
      }
      return <Navigate to="/customer/workspace" replace />;
    }
  }

  return children;
};

export default Protected;
